import CommonImg from "@/components/Common/Img";
import { cn } from "@/libs/utils";

interface CardProps {
  icon: string;
  title: string;
  noBorder?: boolean;
  children: React.ReactNode;
}

export default function Card({
  icon,
  title,
  noBorder = false,
  children,
}: CardProps) {
  return (
    <div className="w-full bg-white rounded-xl border-[1px] border-gray-D">
      <div className="flex gap-2 items-center p-5 pb-4">
        <CommonImg src={icon} alt={title} />
        <span className="text-sm text-gray-A font-semibold">{title}</span>
      </div>
      <div
        className={cn("min-h-[280px]  border-gray-D", {
          "border-t-[1px]": !noBorder,
        })}
      >
        {children}
      </div>
    </div>
  );
}
